import React from 'react';

import Dialog from './Dialog';
import Button from './Button';

function AlertDialog({title, description, ok = 'OK', onOk}) {
  return (
    <Dialog
      title={title}
      description={description}
      buttons={
        <Button autoFocus onClick={onOk}>{ok}</Button>
      }
    />
  );
}

export default AlertDialog;